<script lang="ts">
    import FormV2PrintFrame from './form-v2-print-frame.svelte'
    import FormV2Print from './form-v2-print.svelte'
    import type { PlacedBlock } from '../types/placed-block'
    import type { DocumentHeaderFooter } from '../types/document-header-footer'
    import type { FillContext } from './context-snapshot'

    /**
     * Documento completo pronto pra impressão: a moldura (timbre repetido a cada página) já com o
     * conteúdo dentro. Existe para que o caminho de impressão dentro do app e o da lambda-pdf
     * (página pública) montem exatamente a mesma coisa — o PDF que vai para assinatura precisa ser
     * visualmente idêntico ao documento que a equipe imprime.
     *
     * Repassa o evento `loaded` do FormV2Print, que é o gatilho de impressão de quem chama
     * (share-page.svelte espera por ele antes de disparar window.print()).
     */
    export let blocks: PlacedBlock[] = []
    export let headerFooter: DocumentHeaderFooter
    export let answers: Record<string, any> = {}
    export let context: FillContext = {}
    export let companyId: string | null = null
    export let documentFooterId: string | null = null
</script>

<FormV2PrintFrame {headerFooter} {companyId}>
    <FormV2Print {blocks} {headerFooter} {answers} {context} {companyId} {documentFooterId} omitHeaderFooter={true} on:loaded />
</FormV2PrintFrame>
